import { render, staticRenderFns } from "./ProjectTabOrders.vue?vue&type=template&id=4ef2c18b&scoped=true"
import script from "./ProjectTabOrders.vue?vue&type=script&lang=ts"
export * from "./ProjectTabOrders.vue?vue&type=script&lang=ts"
import style0 from "./ProjectTabOrders.vue?vue&type=style&index=0&id=4ef2c18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef2c18b",
  null
  
)

export default component.exports